import NProgress from 'nprogress'

let timeout = null
let isShowing = false

const start = (event, delay = 500, exclude = []) => {
    const isSamePage =
        window.location.pathname === event.detail.visit.url.pathname

    if (isSamePage && !exclude.includes(route().current())) {
        timeout = setTimeout(() => {
            isShowing = true
            NProgress.start()
            showOverlay()
        }, delay)
    } else if (!isSamePage) {
        timeout = setTimeout(() => {
            isShowing = true
            NProgress.start()
            showOverlay()
        }, delay)
    }
}

const progress = event => {
    if (NProgress.isStarted() && event.detail.progress.percentage) {
        NProgress.set(
            Math.max(
                NProgress.status,
                (event.detail.progress.percentage / 100) * 0.9
            )
        )
    }
}

const finish = event => {
    clearTimeout(timeout)

    if (!isShowing) {
        // If spinner never showed, just clean up
        hideOverlay()
        return
    }

    isShowing = false

    if (event.detail.visit.completed) {
        NProgress.done()
        hideOverlay()
    } else if (event.detail.visit.interrupted) {
        NProgress.set(0)
        hideOverlay()
    } else if (event.detail.visit.cancelled) {
        NProgress.done()
        NProgress.remove()
        hideOverlay()
    } else {
        // Fallback case
        NProgress.done()
        hideOverlay()
    }
}

const showOverlay = () => {
    // Remove existing overlay if any
    hideOverlay()

    // Create overlay element
    const overlay = document.createElement('div')
    overlay.id = 'form-progress-overlay'
    overlay.className = 'form-progress-overlay'

    // Add overlay to body
    document.body.appendChild(overlay)

    // Add blur effect to main content
    const mainContent = document.getElementById('app') || document.body
    if (mainContent && mainContent.id === 'app') {
        mainContent.classList.add('form-progress-blur')
    }
}

const hideOverlay = () => {
    // Remove overlay with fade out
    const overlay = document.getElementById('form-progress-overlay')
    if (overlay) {
        overlay.classList.add('form-progress-overlay-fadeout')
        // Remove after animation completes
        setTimeout(() => {
            if (overlay.parentNode) {
                overlay.remove()
            }
        }, 150) // Match the fadeout duration
    }

    // Remove blur effect from main content
    const mainContent = document.getElementById('app') || document.body
    if (mainContent && mainContent.id === 'app') {
        mainContent.classList.remove('form-progress-blur')
    }
}

function injectCSS(color) {
    const element = document.createElement('style')
    element.type = 'text/css'
    element.textContent = `
    /* Hide the top progress bar completely */
    #nprogress .bar {
      display: none !important;
    }

    #nprogress .peg {
      display: none !important;
    }

    /* Center the spinner and make it larger */
    #nprogress .spinner {
      display: block;
      position: fixed;
      z-index: 10001;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      opacity: 0;
      animation: nprogress-fade-in 150ms ease-out forwards;
    }

    #nprogress .spinner-icon {
      width: 40px;
      height: 40px;
      box-sizing: border-box;
      border: solid 3px transparent;
      border-top-color: ${color};
      border-left-color: ${color};
      border-radius: 50%;
      animation: nprogress-spinner 800ms linear infinite;
    }

    /* Overlay styles with better transitions */
    .form-progress-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.85);
      z-index: 9999;
      pointer-events: none;
      opacity: 0;
      animation: overlay-fade-in 150ms ease-out forwards;
    }

    .form-progress-overlay-fadeout {
      animation: overlay-fade-out 150ms ease-in forwards !important;
    }

    /* Blur effect for main content with faster transition */
    .form-progress-blur {
      filter: blur(2px);
      transition: filter 150ms ease-out;
    }

    /* Fade animations */
    @keyframes nprogress-fade-in {
      0% { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
      100% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
    }

    @keyframes overlay-fade-in {
      0% { opacity: 0; }
      100% { opacity: 1; }
    }

    @keyframes overlay-fade-out {
      0% { opacity: 1; }
      100% { opacity: 0; }
    }

    /* Spinner rotation animation - slower for better visual appeal */
    @keyframes nprogress-spinner {
      0%   { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    /* Ensure proper stacking */
    #nprogress {
      pointer-events: none;
    }

    /* Additional safety to ensure bar is completely hidden */
    #nprogress .bar,
    #nprogress .peg {
      opacity: 0 !important;
      visibility: hidden !important;
      height: 0 !important;
    }
  `
    document.head.appendChild(element)
}

const FormProgress = {
    init({
        delay = 500, // Increased default delay to reduce frequency
        color = '#29d',
        includeCSS = true,
        showSpinner = true,
        exclude = [],
    } = {}) {
        document.addEventListener('inertia:start', event =>
            start(event, delay, exclude)
        )
        document.addEventListener('inertia:progress', progress)
        document.addEventListener('inertia:finish', finish)

        // Configure NProgress with faster completion
        NProgress.configure({
            showSpinner,
            minimum: 0.08,
            easing: 'ease-out', // Changed to ease-out for snappier feel
            speed: 150 // Faster completion speed
        })

        if (includeCSS) {
            injectCSS(color)
        }

        // Clean up on page unload
        window.addEventListener('beforeunload', hideOverlay)
    },
}

export default FormProgress
